"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.Style = exports.CSS = void 0;
var theme_1 = require("../../components/theme");
exports.CSS = {
    container: 'c-TopologicalEditorCollectionListContainer',
    item: 'c-TopologicalEditorCollectionListItem',
    selected: 'c-TopologicalEditorCollectionListItem--selected',
    unsaved: 'c-TopologicalEditorCollectionListItem--unsaved',
    info: 'c-TopologicalEditorCollectionListItem--info',
    noLocation: 'c-TopologicalEditorCollectionListItem--no-location'
};
exports.Style = (_a = {},
    _a[exports.CSS.container] = {
        padding: theme_1.DefaultTheme.space(1),
        flexGrow: '1',
        overflow: 'auto'
    },
    _a[exports.CSS.item] = {
        display: 'flex',
        'align-items': 'center',
        'padding-left': theme_1.DefaultTheme.space(3),
        cursor: 'pointer',
        'border-left': "".concat(theme_1.DefaultTheme.space(1), " solid transparent"),
        '&:hover': {
            backgroundColor: theme_1.DefaultTheme.font.color.divider
        }
    },
    _a[exports.CSS.selected] = {
        'background-color': theme_1.DefaultTheme.background.offWhite,
        'box-shadow': theme_1.DefaultTheme.shadow.box.dp2,
        'border-color': theme_1.DefaultTheme.color.accent
    },
    _a[exports.CSS.unsaved] = {
        'font-style': 'italic',
        flex: 1
    },
    _a[exports.CSS.info] = {
        'font-style': 'italic',
        'text-align': 'right',
        flex: 1,
        'padding-right': theme_1.DefaultTheme.space(1),
        'font-size': '90%',
        color: theme_1.DefaultTheme.font.color.disabled
    },
    _a[exports.CSS.noLocation] = {
        color: theme_1.DefaultTheme.font.color.disabled,
        cursor: 'default'
    },
    _a);
//# sourceMappingURL=topological.editor.collection.list.style.js.map